// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // DevApiUrl: 'http://localhost:60289/api',
  // DevImageUrl: 'http://localhost:60289',
  DevApiUrl: 'https://apis.laderach.sa/api',
  DevImageUrl: 'https://apis.laderach.sa',
  CallBackUrl:'https://laderach.sa/invoice/',
  ErrorUrl : 'https://laderach.sa/error-on-pay'
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
